export const SET_ORG_CUSTOMIZATIONS_BY_ORG_ID =
    "SET_ORG_CUSTOMIZATIONS_BY_ORG_ID";
export const REPLACE_ORG_CUSTOMIZATIONS = "REPLACE_ORG_CUSTOMIZATIONS";
